import type { ShippingAddressFragment } from '@graphql/aliases';
import { isUSAddress } from '@apps/registry/common/utils/shippingAddressValidations';

type ShopAddRefusalsArgs = Readonly<{
  isIntlRestrictedEventSelected: boolean;
  shippingAddress: ShippingAddressFragment | null;
  onAddRefused: () => void;
}>;

/**
 * An international registry gets no Joy store items and no gifts pasted from other stores.
 * A US registry shipping abroad only loses Joy store items, which ship within the US.
 */
export const getShopAddRefusals = ({ isIntlRestrictedEventSelected, shippingAddress, onAddRefused }: ShopAddRefusalsArgs) => {
  const isShippingOutsideUs = !!shippingAddress && !isUSAddress(shippingAddress);
  return {
    onDeliverableAddRefused: isIntlRestrictedEventSelected || isShippingOutsideUs ? onAddRefused : undefined,
    onUniversalSearchAddRefused: isIntlRestrictedEventSelected ? onAddRefused : undefined,
  };
};
